import { create } from "zustand";

export type NetworkStatus = "checking" | "online" | "offline" | "server-unreachable";

type NetworkStatusState = {
  browserOnline: boolean;
  backendReachable: boolean;
  isChecking: boolean;
  lastCheckedAt: string | null;
  setBrowserOnline: (online: boolean) => void;
  setBackendReachable: (reachable: boolean) => void;
  setChecking: (checking: boolean) => void;
  markChecked: () => void;
};

export function resolveNetworkStatus(
  browserOnline: boolean,
  backendReachable: boolean,
  isChecking: boolean
): NetworkStatus {
  if (!browserOnline) return "offline";
  if (isChecking) return "checking";
  return backendReachable ? "online" : "server-unreachable";
}

export const useNetworkStatusStore = create<NetworkStatusState>((set) => ({
  browserOnline: typeof navigator === "undefined" ? true : navigator.onLine,
  backendReachable: true,
  isChecking: true,
  lastCheckedAt: null,
  setBrowserOnline: (online) => set({ browserOnline: online }),
  setBackendReachable: (reachable) => set({ backendReachable: reachable }),
  setChecking: (checking) => set({ isChecking: checking }),
  markChecked: () => set({ lastCheckedAt: new Date().toISOString() }),
}));

export function selectNetworkStatus(state: NetworkStatusState): NetworkStatus {
  return resolveNetworkStatus(state.browserOnline, state.backendReachable, state.isChecking);
}
